import { AbstractControl, NG_VALIDATORS, Validator, Validators } from '@angular/forms';
import { Directive, forwardRef, Input } from '@angular/core';

@Directive({
    selector: '[min][formControlName],[min][formControl],[min][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MinValidatorDirective),
            multi: true,
        },
    ],
})
export class MinValidatorDirective implements Validator {
    @Input()
    min: number;

    validate(control: AbstractControl): { [key: string]: any } {
        return Validators.min(this.min)(control);
    }
}
